import classNames from "classnames"

type PaidValue = "Paid" | "Not-Paid"

type Props = {
  value: PaidValue | string | undefined
  disabled?: boolean
  saving?: boolean
  onChange?: (next: PaidValue) => void
}

export const ReceiptPaidStatusControl = ({
  value,
  disabled,
  saving,
  onChange,
}: Props) => {
  const v =
    value === "Paid" || value === "Not-Paid" ? value : ("Not-Paid" as PaidValue)
  const isPaid = v === "Paid"

  if (!onChange || disabled) {
    return (
      <div className="inline-flex items-center gap-2">
        <span
          className={classNames(
            "rounded-full px-2.5 py-0.5 text-xs font-semibold",
            isPaid
              ? "bg-green-100 text-green-800"
              : "bg-red-100 text-red-800"
          )}
        >
          {isPaid ? "Reviewed" : "Not Reviewed"}
        </span>
      </div>
    )
  }

  return (
    <div className="inline-flex items-center gap-2">
      <span
        className={classNames(
          "rounded-full px-2.5 py-0.5 text-xs font-semibold shrink-0",
          isPaid
            ? "bg-green-100 text-green-800"
            : "bg-red-100 text-red-800"
        )}
      >
        {isPaid ? "Reviewed" : "Not Reviewed"}
      </span>
      <button
        type="button"
        role="switch"
        aria-checked={isPaid}
        title="Toggle reviewed"
        disabled={!!saving}
        onClick={() => onChange(isPaid ? "Not-Paid" : "Paid")}
        className={classNames(
          "relative inline-flex h-7 w-12 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-1",
          saving && "opacity-50 cursor-wait",
          isPaid ? "bg-green-500" : "bg-rose-500"
        )}
      >
        <span
          className={classNames(
            "pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out mt-0.5",
            isPaid ? "translate-x-6" : "translate-x-1"
          )}
        />
      </button>
    </div>
  )
}
